import moment from "moment";

const DefaultDateFormat = "YYYY-MM-DD";
const DefaultTimeFormat = "HH:mm:ss";

let dateFormat = DefaultDateFormat;
let timeFormat = DefaultTimeFormat;

export interface DateTimeFormatOptions {
  reference?: "utc" | "local" | "relative";
  template?: string;
}

export const setDateTimeFormat = (
  dateFormatExpression: string = DefaultDateFormat,
  timeFormatExpression: string = DefaultTimeFormat,
) => {
  dateFormat = dateFormatExpression;
  timeFormat = timeFormatExpression;
};

export const getDateTimeFormat = () => {
  return {
    date: dateFormat,
    time: timeFormat,
  };
};

export const parseIso8601String = (iso8601String: string) => {
  if (iso8601String) {
    const dateTimeMoment = moment(iso8601String);
    if (dateTimeMoment.isValid()) {
      return {
        date: dateTimeMoment.format(dateFormat),
        time: dateTimeMoment.format(timeFormat),
      };
    }
  }
  return undefined;
};

export const formatIso8601String = (
  iso8601String: string,
  includePortion?: "date" | "time",
  options?: DateTimeFormatOptions,
) => {
  const defaultTemplate = includePortion
    ? includePortion === "date"
      ? dateFormat
      : timeFormat
    : `${dateFormat} ${timeFormat}`;

  let dateTimeMoment = moment(iso8601String);

  if (dateTimeMoment.isValid()) {
    if (options && options.reference === "relative") {
      return dateTimeMoment.fromNow();
    } else {
      if (options && options.reference === "utc") {
        dateTimeMoment = dateTimeMoment.utc();
      }
      return dateTimeMoment.format((options && options.template) || defaultTemplate);
    }
  }

  return undefined;
};

export const formatUnixTime = (unixTime: number, includePortion?: "date" | "time", options?: DateTimeFormatOptions) => {
  const defaultTemplate = includePortion
    ? includePortion === "date"
      ? dateFormat
      : timeFormat
    : `${dateFormat} ${timeFormat}`;

  let dateTimeMoment = moment.unix(unixTime);

  if (dateTimeMoment.isValid()) {
    if (options && options.reference === "relative") {
      return dateTimeMoment.fromNow();
    } else {
      if (options && options.reference === "utc") {
        dateTimeMoment = dateTimeMoment.utc();
      }
      return dateTimeMoment.format((options && options.template) || defaultTemplate);
    }
  }

  return undefined;
};
